
export default class CookieConsentManager {
    static enable(service) {
        return localStorage.setItem('cookieconsent_' + service, '1');
    }
    static hasConsent(service) {
        return localStorage.getItem('cookieconsent_' + service) === '1';
    }

    /*
     * Executes the callback, after we got consent
     */
    static onHasConsent(service, callback) {
        if(CookieConsentManager.hasConsent(service)) {
            callback();
        } else {
            // TODO Make clean implementation
            setTimeout(() => CookieConsentManager.onHasConsent(service, callback), 200);
        }
    }
}
